import React from 'react';
import {Col, Row} from 'reactstrap';

const PopupSubTitleComponent = (props) => {
 return (
     <Row>
        <Col>
            <span className="bold d-block popup-component-subTitle" dangerouslySetInnerHTML={{ __html: props.subTitle }} />
        </Col>
     </Row>
 )
}

export default PopupSubTitleComponent;


